export default "__VITE_ASSET__CXX6U24x__"